export const data = { 'version': 6303, 'gitMessage': 'fix buterfuly', 'date': '2025-03-14 10:09:42'};
